export default {
  secaoRHID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  contaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  email: {
    value: null,
    maxlength: '70',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/coordinator/coordinator-form.js